import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * "Something may have changed the balance — re-read it."
 *
 * A one-line bus rather than the header polling or the studio reaching into it.
 * The credit pill lives in HeaderComponent and the spending happens in the AI
 * studio; neither can see the other, and wiring a direct reference between them
 * would mean the studio knowing what a header is.
 *
 * Nothing is carried on the signal. The header already knows how to read the
 * balance for whoever is signed in, so the message only has to be that it is
 * worth reading again.
 *
 * AppInterceptor raises it on every successful POST to our own backends, which
 * is what makes this cover calls nobody has written yet: a new studio endpoint
 * refreshes the pill without anyone remembering to add it here.
 */
@Injectable({
    providedIn: 'root'
})
export class CreditsRefreshService {

    private readonly pings = new Subject<void>();

    /** Emits when the balance should be re-read. */
    readonly changes$: Observable<void> = this.pings.asObservable();

    ping(): void {
        this.pings.next();
    }
}
